module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("DIED IN"), _c('br'), _vm._v("\n  THE WOOL")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Ngaio Marsh")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELONY")]), _vm._v(" & M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYHEM")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(" • N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")])])]), _vm._v(" "), _c('p', {
    staticClass: "img1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/frn_fig_002.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d043d97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TitlePage.vue
// module id = 60
// module chunks = 0